<template>
  <el-dialog
    width="1400px"
    :title="!dataForm.id ? 'Add Quotation (V)' : 'Edit Quotation (V)'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="close"
    top="1vh"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Transaction Type" prop="transactionType">
            <el-select v-model="dataForm.transactionType" clearable class="wdb100">
              <el-option v-for="item in transactionTypeList" :key="`transactionType-${item.title}`" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Linked Transaction No." prop="applymentNo">
            <business-info-select-remote-search v-model="dataForm.applymentNo" placeholder="Transaction No."></business-info-select-remote-search>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="dataForm.transactionType == 2">
          <el-form-item label="Order No." prop="refundOrderIds">
            <template v-if="dataForm.applymentNo">
              <el-select
                v-model="dataForm.refundOrderIds"
                multiple
                filterable
                clearable
                placeholder="Order No."
                :loading="refundOrderLoading"
                class="wdb100"
              >
                <el-option v-for="item in refundOrderOptions" :key="`refundOrder-${item.id}`" :label="item.orderNo" :value="item.id"></el-option>
              </el-select>
            </template>
            <div class="pt0 pb0 notSelectTipBg" v-else>Select Linked Transaction No. first</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Client Code" prop="clientCode">
            <client-code-select-remote-search
              v-model="dataForm.clientCode"
              :showItems="['companyName', 'billingAddresses']"
              placeholder="Client Code"
              @change-item="clientCodeChange"
            ></client-code-select-remote-search>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Billing Party" prop="billingParty">
            <el-input v-model="dataForm.billingParty" clearable placeholder="Billing party"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Address" prop="address">
            <el-input v-model="dataForm.address" clearable placeholder="Address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Country" prop="country">
            <el-select v-model="dataForm.country" placeholder="Country" clearable filterable class="wdb100">
              <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Postal Code" prop="postalCode">
            <el-input v-model="dataForm.postalCode" clearable placeholder="Postal Code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Supplier" prop="supplierId">
            <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier" class="wdb100" @change="supplierChange">
              <el-option v-for="item in supplierList" :key="`supplier-${item.id}`" :label="item.companyName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Invoice Template" prop="invoiceTemplateId">
            <template v-if="dataForm.supplierId">
              <el-select v-model="dataForm.invoiceTemplateId" clearable filterable class="wdb100" @change="invoiceTemplateChange">
                <el-option
                  v-for="item in invoiceTemplateOptions"
                  :key="`invoiceTemplate-${item.id}`"
                  :label="item.templateName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
            <div class="pt0 pb0 notSelectTipBg" v-else>Select supplier first</div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="Bank Accounts" prop="bankAccountIds">
            <template v-if="dataForm.invoiceTemplateId">
              <select-bank-account v-model="dataForm.bankAccountIds" :supplierBankAccountList="invoiceTemplateBankAccountList" />
            </template>
            <div class="notSelectTipBg" v-else>Select invoice template first</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Quotation (V) Items" prop="itemList">
            <div class="addBtnWrap">
              <el-button type="primary" icon="el-icon-plus" size="mini" plain @click="addHandle">Add Item</el-button>
            </div>
            <div class="itemListWrap">
              <el-row :gutter="5">
                <el-col :span="1" class="itemTitle">&nbsp;</el-col>
                <el-col :span="3" class="itemTitle">Category</el-col>
                <el-col :span="8" class="itemTitle">Description</el-col>
                <el-col :span="2" class="itemTitle">Currency</el-col>
                <el-col :span="3" class="itemTitle">Orig. Amount</el-col>
                <el-col :span="3" class="itemTitle">Ex Rate</el-col>
                <el-col :span="3" class="itemTitle">Amount</el-col>
              </el-row>
              <div class="wdb100" v-for="(ele, index) in dataForm.itemList" :key="`category-${index}`">
                <el-row :gutter="5">
                  <el-col :span="1">
                    <el-button type="text" size="mini" class="pd0 fwb el-icon-top" :disabled="index == 0" @click="moveItem(index, -1)"></el-button>
                    <el-button
                      type="text"
                      size="mini"
                      class="pd0 fwb el-icon-bottom"
                      :disabled="index == dataForm.itemList.length - 1"
                      @click="moveItem(index, 1)"
                    ></el-button>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item
                      :prop="`itemList.${index}.category`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                    >
                      <el-select v-model="ele.category" clearable filterable placeholder="Category" class="wdb100">
                        <el-option
                          v-for="item in invoiceItemCategoryList"
                          :key="`category-${item.value}-${index}`"
                          :label="item.title"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      :prop="`itemList.${index}.description`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="ele.description" clearable placeholder="Description"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <el-form-item
                      :prop="`itemList.${index}.originalCurrency`"
                      :rules="{
                        required: true,
                        message: 'please select',
                        trigger: 'submit',
                      }"
                    >
                      <el-select v-model="ele.originalCurrency" filterable clearable placeholder="Currency" class="wdb100">
                        <el-option v-for="item in currencyList" :key="item.currency" :label="item.currency" :value="item.currency"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item
                      :prop="`itemList.${index}.originalAmount`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="ele.originalAmount" clearable placeholder="Orig. Amount" v-minusPoint2 @input="calculateTotal(ele)">
                        <template slot="prefix">{{ currencySymbolFormat(ele.originalCurrency) }}</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item
                      :prop="`itemList.${index}.exchangeRate`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="ele.exchangeRate" clearable placeholder="Ex Rate" v-positivePoint="6" @input="calculateTotal(ele)"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="3">
                    <el-form-item
                      :prop="`itemList.${index}.billingAmount`"
                      :rules="{
                        required: true,
                        message: 'please enter',
                        trigger: 'submit',
                      }"
                    >
                      <el-input v-model="ele.billingAmount" clearable placeholder="Amount" v-minusPoint2>
                        <template slot="prefix">{{ currencySymbolFormat(billingCurrency) }}</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" class="tac">
                    <el-button type="danger" size="small" icon="el-icon-delete" plain @click="deleteHandle(index)"></el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="dataForm.transactionType == 2 ? 'Apply Reason (For External Disclosure)' : 'Description (For External Disclosure)'"
            prop="applyReason"
          >
            <el-input
              v-model="dataForm.applyReason"
              type="textarea"
              :rows="5"
              :autosize="{ minRows: 4 }"
              resize="none"
              placeholder="English wording is mandatory, Chinese translation is optional"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Attachments" prop="attachmentUrls">
            <el-multiple-file-uploader v-model="dataForm.attachmentUrls"></el-multiple-file-uploader>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BusinessInfoSelectRemoteSearch from "@/components/SelectRemoteSearch/businessInfo";
import ClientCodeSelectRemoteSearch from "@/components/SelectRemoteSearch/clientCode";
import SelectBankAccount from "@/components/SelectBankAccount";
import formatterMixin from "@/mixins/formatterMixin";
import { isNumberLike } from "@/utils";
import { multiply, toFixedDecimal } from "@/utils/count";
import { mapState } from "vuex";
export default {
  mixins: [formatterMixin],
  props: {
    invoiceTemplateList: {
      type: Array,
      default: () => [],
    },
    supplierList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BusinessInfoSelectRemoteSearch,
    ClientCodeSelectRemoteSearch,
    SelectBankAccount,
  },
  data() {
    return {
      visible: false,
      dataForm: {
        id: null,
        transactionType: null,
        applymentNo: "",
        clientCode: "",
        billingParty: "",
        address: "",
        country: "",
        postalCode: "",
        invoiceTemplateId: null,
        applyReason: "",
        attachmentUrls: [],
        bankAccountIds: [],
        itemList: [],
        supplierId: null,
        refundOrderIds: [],
      },
      dataRule: {
        transactionType: [{ required: true, message: "please select", trigger: "submit" }],
        applymentNo: [{ required: true, message: "please select", trigger: "submit" }],
        billingParty: [{ required: true, message: "please enter", trigger: "submit" }],
        invoiceTemplateId: [{ required: true, message: "please select", trigger: "submit" }],
        applyReason: [{ required: true, message: "please enter", trigger: "submit" }],
        bankAccountIds: [{ type: "array", required: true, message: "please select", trigger: "submit" }],
        itemList: [{ type: "array", required: true, message: "please add", trigger: "submit" }],
        supplierId: [{ required: true, message: "please select", trigger: "submit" }],
        refundOrderIds: [{ type: "array", required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
      refundOrderOptions: [],
      refundOrderLoading: false,
      isInitializing: false,
    };
  },
  computed: {
    ...mapState("constant", ["transactionTypeList", "countryList", "invoiceItemCategoryList"]),
    ...mapState("currency", ["currencyList"]),
    // 开票币种
    billingCurrency() {
      // 通过选中的发票id来匹配对应的银行账号列表
      const invoiceTemplateId = this.dataForm.invoiceTemplateId;
      const bankAccountList = this.invoiceTemplateList?.find(item => item.id == invoiceTemplateId)?.bankAccountList || [];
      // 选中的第一个银行的币种作为开票币种
      const firstBankAccountId = this.dataForm.bankAccountIds[0];
      const currency = bankAccountList.find(item => item.id == firstBankAccountId)?.billingCurrency;
      return currency || "";
    },
    // 银行账号列表
    invoiceTemplateBankAccountList() {
      // 通过选中的发票id来匹配对应的银行账号列表
      const invoiceTemplateId = this.dataForm.invoiceTemplateId;
      const bankAccountList = this.invoiceTemplateList?.find(item => item.id == invoiceTemplateId)?.bankAccountList;
      return bankAccountList || [];
    },
    // 根据选中的服务商id,获取对应的发票模板列表
    invoiceTemplateOptions() {
      const supplierId = this.dataForm.supplierId;
      const transactionType = this.dataForm.transactionType;
      return (
        this.invoiceTemplateList?.filter(item => {
          if (item.supplier?.id != supplierId) return false;
          // transactionType == 1 只保留 invoiceType == 1, == 2 只保留 invoiceType == 2
          if (transactionType == 1) return item.invoiceType == 1;
          if (transactionType == 2) return item.invoiceType == 2;
          return true;
        }) || []
      );
    },
  },
  watch: {
    // Transaction Type 变化: 清空关联字段; ==2 时拉取 refundOrder 选项, 否则清空
    "dataForm.transactionType"(val) {
      if (this.isInitializing) return;
      this.$set(this.dataForm, "invoiceTemplateId", null);
      this.$set(this.dataForm, "bankAccountIds", []);
      if (val == 2) {
        if (this.dataForm.applymentNo) {
          this.fetchRefundOrderOptions(this.dataForm.applymentNo);
        }
      } else {
        this.$set(this.dataForm, "refundOrderIds", []);
        this.refundOrderOptions = [];
      }
    },
    // Linked Transaction No. 变化: 在 transactionType==2 时清空 refundOrderIds 并重新拉取选项
    "dataForm.applymentNo"(val) {
      if (this.isInitializing) return;
      if (this.dataForm.transactionType == 2) {
        this.$set(this.dataForm, "refundOrderIds", []);
        if (val) {
          this.fetchRefundOrderOptions(val);
        } else {
          this.refundOrderOptions = [];
        }
      }
    },
  },
  methods: {
    // 初始化
    async init(data, applymentNo) {
      this.visible = true;
      this.submitLoading = false;
      this.isInitializing = true;
      // 需要手动设置itemList为[],不然会报错
      this.$set(this.dataForm, "itemList", []);
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        const dataCopy = JSON.parse(JSON.stringify(data));
        const refundOrderIds = dataCopy.refundOrderList?.map(item => item.id) || [];
        this.dataForm = {
          id: dataCopy.id,
          applymentNo: dataCopy.applymentNo,
          clientCode: dataCopy.clientCode,
          billingParty: dataCopy.billingParty,
          address: dataCopy.address,
          country: dataCopy.country,
          postalCode: dataCopy.postalCode,
          invoiceTemplateId: dataCopy.invoiceTemplateId,
          applyReason: dataCopy.applyReason,
          attachmentUrls: dataCopy.attachmentUrls || [],
          bankAccountIds: dataCopy.bankAccountIds || [],
          itemList: dataCopy.itemList || [],
          supplierId: dataCopy.supplierId,
          transactionType: dataCopy.transactionType,
          refundOrderIds,
        };
        // 编辑回显时, 若 transactionType==2 且有 applymentNo, 主动拉取选项
        if (dataCopy.transactionType == 2 && dataCopy.applymentNo) {
          this.fetchRefundOrderOptions(dataCopy.applymentNo);
        }
      } else {
        this.$set(this.dataForm, "id", null);
        this.$set(this.dataForm, "applymentNo", applymentNo);
      }
      // 等待 Vue 2 异步 watch 回调执行完毕后再关闭标志位
      await this.$nextTick();
      await this.$nextTick();
      this.isInitializing = false;
    },
    // Client Code 选中时自动填充对应信息
    clientCodeChange(data) {
      if (!data) return;
      this.$set(this.dataForm, "billingParty", data.companyName || "");
      const billingInfoItem = data.billingInfoItem || {};
      this.$set(this.dataForm, "address", billingInfoItem.billingAddress || "");
      this.$set(this.dataForm, "country", billingInfoItem.billingCountry || "");
      this.$set(this.dataForm, "postalCode", billingInfoItem.billingPostalCode || "");
    },
    // Supplier - Change
    supplierChange() {
      this.$set(this.dataForm, "invoiceTemplateId", null);
      this.$set(this.dataForm, "bankAccountIds", []);
    },
    // Invoice Template - Change
    invoiceTemplateChange() {
      this.$set(this.dataForm, "bankAccountIds", []);
    },
    // 拉取 refundOrder 选项 (Invoice No. 多选下拉框)
    async fetchRefundOrderOptions(businessNo) {
      if (!businessNo) {
        this.refundOrderOptions = [];
        return;
      }
      this.refundOrderLoading = true;
      try {
        const res = await this.$http.get("/admin/customerOrderMa/getRelatedOrderListByBusinessNo", {
          params: { businessNo },
        });
        this.refundOrderOptions = res.data || [];
      } catch (e) {
        this.refundOrderOptions = [];
      } finally {
        this.refundOrderLoading = false;
      }
    },
    // 表单提交
    async formSubmitRequest() {
      const params = {
        ...this.dataForm,
      };
      if (params.id) {
        return await this.$http.post(`/admin/adjustment/${params.id}/update`, params);
      } else {
        return await this.$http.post("/admin/adjustment/create", params);
      }
    },
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.formSubmitRequest()
            .then(res => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch(err => {
              this.submitLoading = false;
            });
        }
      });
    },
    // Quotation (V) Items - 添加
    addHandle() {
      this.dataForm.itemList.push({
        category: "",
        description: "",
        originalCurrency: "",
        originalAmount: "",
        exchangeRate: "",
        billingAmount: "",
      });
    },
    // Quotation (V) Items - 删除
    deleteHandle(index) {
      this.dataForm.itemList.splice(index, 1);
    },
    // Quotation (V) Items - 排序
    moveItem(index, direction) {
      const nextIndex = index + direction;
      if (nextIndex < 0 || nextIndex >= this.dataForm.itemList.length) return;
      const targetItem = this.dataForm.itemList.splice(index, 1)[0];
      this.dataForm.itemList.splice(nextIndex, 0, targetItem);
    },
    // Quotation (V) Items - 设置Amount
    calculateTotal(ele) {
      const amount = ele.originalAmount;
      const rate = ele.exchangeRate;
      if (isNumberLike(amount) && isNumberLike(rate)) {
        // 四舍五入保留2位小数
        const total = toFixedDecimal(multiply(amount, rate), 2);
        ele.billingAmount = total;
      }
    },
    // 弹窗关闭时
    close() {
      // 检查当前是否有参数，避免重复点击报错
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({
          path: this.$route.path,
          query: {}, // 传入空对象，清空所有 ? 后的参数
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.addBtnWrap {
  text-align: right;
  margin-top: -32px;
}

.itemListWrap {
  margin-top: 8px;
  padding: 0px 10px;
  background: #f5f7fa;
  border-radius: 2px;

  .itemTitle {
    font-size: 13px;
    text-align: center;
  }

  .notSelectTipBg {
    padding: 6px 10px;
    background: #f5f7fa;
    border-radius: 2px;
  }
}
</style>
